import Device2nIcon from './Device2NIcon';

export default Device2nIcon;
